// extracted by mini-css-extract-plugin
module.exports = {"accordionItems":"archive-faq_accordionItems__B4ZaI","faqCatTitle":"archive-faq_faqCatTitle__qoG9Q"};